import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getCoupon, updateCoupon } from "../../services/coupon.service";
import { useSelector } from "react-redux";

export default function CouponUpdate() {
  const { token } = useSelector((state) => state?.auth);
  const [isLoading2, setIsLoading2] = useState(false);
  const [couponType, setCouponType] = useState("Amount");
  const [coupon, setCoupon] = useState(null);
  const navigate = useNavigate()
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const couponId = params.get("id");

  const handleCouponTypeChange = (event) => {
    const type = event.target.value;
    setCouponType(type);
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    clearErrors,
  } = useForm();

  const fetchCoupon = async () => {
    try {
      const res = await getCoupon(token, couponId);

      if (res && res.status >= 200 && res.status < 300) {
        // console.log(res.data);

        setCoupon(res?.data);
      } else {
        Swal.fire(
          "Error",
          "Failed to fetch coupon details. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error fetching coupon details:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching the coupon. Please try again later.",
        "error"
      );
    }
  };

  useEffect(() => {
    if (couponId) {
      fetchCoupon();
    }
  }, [couponId]);

  useEffect(() => {
    if (coupon) {
      setValue("couponCode", coupon.coupon_code);
      setValue(
        "amountOrPercent",
        coupon.coupon_type === "Amount"
          ? coupon.coupon_amount
          : coupon.coupon_percent
      );
      setValue("minAmount", coupon.min_applicable_amount);
      setValue("expiryDate", coupon.expiry_date);
      setValue("allowCoupons", coupon.max_allowed_coupon);
      setValue("offerText", coupon.offer_text);
      setCouponType(coupon.coupon_type);
    }
  }, [coupon]);

  const onSubmit = async (item) => {
    setIsLoading2(true);
  
    const data = {
      coupon_code: item.couponCode,
      coupon_type: couponType,
      ...(couponType === "Amount"
        ? { coupon_amount: item.amountOrPercent }
        : { coupon_percent: item.amountOrPercent }),
      min_applicable_amount: item.minAmount,
      expiry_date: item.expiryDate,
      max_allowed_coupon: item.allowCoupons,
      offer_text: item.offerText,
    };
  
    // console.log(data);
  
    try {
      const res = await updateCoupon(token, data, couponId);
  
      // console.log(res.data);
  
      if (res && res.status >= 200 && res.status < 300) {
        Swal.fire({
          title: "Updated!",
          text: `Coupon ${item.couponCode} has been updated successfully.`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/coupons");
        });
      } else if (res && res.status >= 400 && res.status < 500) {
        Swal.fire(
          "Error",
          res?.data?.details?.coupon_code[0] ||
            "Invalid input. Please check your data.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          res?.data?.error || "An unexpected error occurred. Please try again later.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during updating coupon:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.error || "A network or server error occurred. Please try again later.",
        "error"
      );
    } finally {
      setIsLoading2(false);
    }
  };
  

  return (
    <div className="content-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Coupon</h4>
                <Link to="/coupons">
                  <img src="/assets/images/kidskart/icon/back-button.png" />
                </Link>{" "}
              </div>
              <div className="card-body py-3">
                <div className="basic-form">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      {/* Coupon Type */}
                      <div className="mb-4 col-md-6">
                        <label className="form-label">Coupon Type</label>
                        <div className="d-flex">
                          <div className="form-check me-3">
                            <input
                              type="radio"
                              id="amountType"
                              value="Amount"
                              className="form-check-input"
                              checked={couponType === "Amount"}
                              onChange={handleCouponTypeChange}
                            />
                            <label
                              htmlFor="amountType"
                              className="form-check-label"
                            >
                              Amount
                            </label>
                          </div>
                          <div className="form-check">
                            <input
                              type="radio"
                              id="percentType"
                              value="Percentage"
                              className="form-check-input"
                              checked={couponType === "Percentage"}
                              onChange={handleCouponTypeChange}
                            />
                            <label
                              htmlFor="percentType"
                              className="form-check-label"
                            >
                              Percent
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Coupon code */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Coupon Code</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter coupon name"
                          {...register("couponCode", {
                            required: "Coupon Code  is required",
                          })}
                        />
                        {errors.couponCode && (
                          <p className="error">{errors.couponCode.message}</p>
                        )}
                      </div>

                      {/* Coupon percent amount */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">
                            {" "}
                            {couponType === "Percentage"
                              ? "Coupon Percent(%)"
                              : "Coupon Amount(₹)"}
                          </label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="number"
                          className="form-control"
                          placeholder={
                            couponType === "Percentage"
                              ? "Enter Coupon Percent"
                              : "Enter Coupon Amount"
                          }
                          {...register("amountOrPercent", {
                            required: `Coupon ${
                              couponType === "Percentage"
                                ? "Percentage"
                                : "Amount"
                            } is required`,
                            validate: (value) => {
                              if (isNaN(value) || value <= 0) {
                                return "Value must be a positive number";
                              }
                            },
                          })}
                        />
                        {errors.amountOrPercent && (
                          <p className="error">
                            {errors.amountOrPercent.message}
                          </p>
                        )}
                      </div>

                      {/* Min amount */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">
                            Min. Applicable Amt(₹)
                          </label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Minimum Amount"
                          {...register("minAmount", {
                            required: "minimum amount is required",
                          })}
                        />
                        {errors.minAmount && (
                          <p className="error">{errors.minAmount.message}</p>
                        )}
                      </div>

                      {/* Expiry Date */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">Expiry Date</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="date"
                          className="form-control"
                          {...register("expiryDate", {
                            required: "Expiry date is required",
                          })}
                        />
                        {errors.expiryDate && (
                          <p className="error">{errors.expiryDate.message}</p>
                        )}
                      </div>

                      {/* Max Allowed coupons */}
                      <div className="mb-4 col-md-6">
                        <div className="d-flex">
                          <label className="form-label">
                            Max. Allowed Coupon
                          </label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Max Allowed Coupons"
                          {...register("allowCoupons", {
                            required: "Allowed coupons is required",
                          })}
                        />
                        {errors.allowCoupons && (
                          <p className="error">{errors.allowCoupons.message}</p>
                        )}
                      </div>

                      {/* Offer Text */}
                      <div className="mb-4 col-md-12">
                        <div className="d-flex">
                          <label className="form-label">Offer Text</label>
                          <i class="fa-solid fa-asterisk asterisk ms-1 mt-1"></i>
                        </div>
                        <textarea
                          rows="3"
                          className="form-control"
                          placeholder="Enter Offer"
                          {...register("offerText", {
                            required: "Offer text is required",
                          })}
                        ></textarea>
                        {errors.offerText && (
                          <p className="error">{errors.offerText.message}</p>
                        )}
                      </div>
                    </div>

                    {!isLoading2 ? (
                      <div className="col-sm-4">
                        <button type="submit" className="btn btn-primary w-100">
                          UPDATE COUPON
                        </button>
                      </div>
                    ) : (
                      <div className="col-sm-4">
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          UPDATING COUPON
                        </button>

                        <div
                          className="spinner-border2 text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
